export type Props = {
  apiKey: string
  q: string
}

const GoogleMapsEmbed = ({apiKey, q}: Props) => {
  const query = q?.trim()

  if (!query) {
    return null
  }

  const embedUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(query)}`

  return <iframe
    style={{border: 0, width: '100%', height: '100%'}}
    loading="lazy"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
    src={embedUrl}>
  </iframe>
}

export default GoogleMapsEmbed
